import "./assets/RideGlyph.css";
const _ = {
  "ride-glyph": "_ride-glyph_bp3nw_1",
  "size-small": "_size-small_bp3nw_6",
  "size-medium": "_size-medium_bp3nw_10",
  "size-large": "_size-large_bp3nw_14",
  "size-x-large": "_size-x-large_bp3nw_18",
  "size-2x-large": "_size-2x-large_bp3nw_22"
};
export {
  _ as s
};
